import { render, staticRenderFns } from "./JtSearchOwnershipChangeModal.vue?vue&type=template&id=7bd04187"
import script from "./JtSearchOwnershipChangeModal.vue?vue&type=script&lang=js"
export * from "./JtSearchOwnershipChangeModal.vue?vue&type=script&lang=js"
import style0 from "./JtSearchOwnershipChangeModal.vue?vue&type=style&index=0&id=7bd04187&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports